import { checkDeploy } from '../services/deployCheck/actions';

const checkDeployMiddleware = (store) => (next) => (action) => {
  const shouldCheckDeploy = action.type === 'HISTORY_LOCATION_CHANGE';

  if (shouldCheckDeploy) {
    const prevDeployId = store.getState().deployCheck.deployId;

    store.dispatch(checkDeploy(prevDeployId));
  }

  return next(action);
};

export default checkDeployMiddleware;
